import { motion } from "framer-motion";

export default function Monitoring() {
  return (
    <section
      className="relative py-20 px-6 text-white"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.85) 0%, rgba(249,122,8,0.3) 100%), url('/assets/s1.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      {/* 🔥 CONTENT WRAPPER */}
      <div className="max-w-6xl mx-auto">
        {/* 🔥 Heading with animation */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-orange-400 mb-4">
            Solar Smart Monitoring ⚡
          </h2>

          <p className="text-white/80 max-w-2xl mx-auto leading-relaxed">
            Monitor, control, and optimize your solar energy system with
            advanced smart monitoring solutions. Stay connected in real-time and
            maximize your system performance effortlessly.
          </p>
        </motion.div>

        {/* 🔥 SECTIONS */}
        <div className="space-y-24">
          {[
            {
              title: "Real-Time Energy Monitoring",
              desc: `Solar smart monitoring systems provide real-time tracking of your solar energy production. 
You can monitor how much electricity your system is generating at any moment. 
It helps identify performance issues instantly.`,
              img: "/assets/products/monitor1.jpg",
            },
            {
              title: "Mobile App Integration",
              desc: `Users can monitor their system anytime, anywhere. 
Real-time alerts and notifications keep you updated. 
Control your system easily through mobile apps.`,
              img: "/assets/products/monitor2.jpg",
            },
            {
              title: "Performance Analytics",
              desc: `Analyze system performance with detailed reports. 
Identify inefficiencies and optimize energy usage. 
Improve return on investment.`,
              img: "/assets/products/monitor3.png",
            },
            {
              title: "Fault Detection System",
              desc: `Automatically detects system faults. 
Reduces downtime and prevents failures. 
Ensures continuous energy production.`,
              img: "/assets/products/Fault.png",
            },
            {
              title: "Remote System Control",
              desc: `Control your solar system remotely. 
Adjust settings and manage performance easily. 
Improves flexibility and convenience.`,
              img: "/assets/products/remote.jpg",
            },
            {
              title: "Energy Saving Optimization",
              desc: `Optimize energy consumption smartly. 
Reduce electricity bills and improve efficiency. 
Supports eco-friendly energy usage.`,
              img: "/assets/products/Energysaver.jpg",
            },
          ].map((item, i) => {
            const isReverse = i % 2 !== 0;

            return (
              <div key={i} className="grid md:grid-cols-2 gap-10 items-center">
                {/* IMAGE */}
                <motion.div
                  initial={{ opacity: 0, x: isReverse ? 50 : -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6 }}
                  className={`${isReverse ? "md:order-2" : ""} overflow-hidden rounded-2xl`}
                >
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-[320px] object-cover hover:scale-110 transition duration-500 rounded-2xl shadow-[0_0_30px_rgba(249,115,22,0.2)]"
                  />
                </motion.div>

                {/* TEXT CARD */}
                <motion.div
                  initial={{ opacity: 0, x: isReverse ? -50 : 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6 }}
                  className={`${isReverse ? "md:order-1" : ""}`}
                >
                  <div className="bg-black/40 backdrop-blur-md p-6 rounded-xl border border-orange-500/20 hover:border-orange-400 hover:shadow-[0_0_25px_rgba(249,115,22,0.4)] transition">
                    <h3 className="text-2xl font-bold text-orange-400 mb-4">
                      {item.title}
                    </h3>

                    <p className="text-white/80 leading-relaxed whitespace-pre-line">
                      {item.desc}
                    </p>
                  </div>
                </motion.div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
